<template>
 <v-dialog v-model="opened" max-width="300">
    <v-card  
    style="width:300px;" 
     v-bind:class="{ 'show' : !opened}">
        <v-card-media
          class="white--text"
          height="200px"
          :src="marker.mainImg[0].url"
         
        >
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs10 align-end flexbox>
                <span class="headline">{{marker.title[lang]}}</span>
              </v-flex>
              <v-flex xs2> <v-btn class="ma-0" small fab flat @click="close" ><v-icon dark>close</v-icon></v-btn></v-flex>
            </v-layout>
          </v-container>
        </v-card-media>
        <v-card-title>
          <div>
            <span class="grey--text">{{minimize(marker.description[lang],20)}}</span><br>
            <!-- <span>Whitehaven Beach</span><br> -->
            <span>{{marker.location.formatted_address}}</span>
          </div>
          
        </v-card-title>
        <v-card-actions>
          <!-- <v-btn flat color="orange">Share</v-btn> -->
          <v-btn flat color="orange" :to="'/artefacts/'+marker._id">Explore</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
</template>
<script>
export default {
  props:['opened','marker'],
  methods: {
      close () {
          this.$emit('close')
      },
          minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;
      else
        return (
          str
            .split(" ")
            .slice(0, spaces - 1)
            .join(" ") + "..."
        );
    }
  }
}
</script>
<style>
.vue-map-hidden {
    display: block;
}
.show {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/InfoWindowDialog.vue